import type { FeatureManifest } from '@/platform/navigation/featureManifest'

export const myEmployeeProfileManifest: FeatureManifest = {
  id: 'employee-self-info',
  path: 'employee-info',
  navPath: '/employee-info',
  label: 'Thông tin nhân viên',
  requiredPermissions: [],
  navigationGroup: { id: 'employee-self', label: 'Thông tin cá nhân' },
  load: () => import('./entry'),
}
